module.exports = __webpack_public_path__ + "static/media/callDark.d46add66.svg";